import React, { Component } from 'react'

import {
  Switch,
  Route
} from 'react-router-dom'

import NaviBar from './components/NaviBar'
import NaviIconMenu from './components/NaviIconMenu'
import Footer from '../common/component/Footer'
import Login from './pages/public/Login'
import PasswordReset from './pages/public/PasswordReset'
import Dashboard from './pages/secure/Dashboard'
import InformationList from './pages/secure/InformationList'
import InformationDetail from './pages/secure/InformationDetail'

import SharedFileList from './pages/secure/SharedFileList'
import SharedFileDetail from './pages/secure/SharedFileDetail'

import RoutineTaskHome from './pages/secure/RoutineTaskHome'

import PersonalSettingHome from './pages/secure/PersonalSettingHome'
import PasswordChange from './pages/secure/PasswordChange'
import EmailChange from './pages/secure/EmailChange'
import NotificationSettingChange from './pages/secure/NotificationSettingChange'

import CompanyDetail from './pages/secure/CompanyDetail'
import CompanyEdit from './pages/secure/CompanyEdit'
import CompanyAdd from './pages/secure/CompanyAdd'

import CompanyUserList from './pages/secure/CompanyUserList'
import CompanyUserEdit from './pages/secure/CompanyUserEdit'
import CompanyUserDetail from './pages/secure/CompanyUserDetail'

import SurveyAnswer from './pages/secure/SurveyAnswer'

import AWSAPI from '../common/AWSAPI'

class CompanyAdminApp extends Component {
  renderPublicPages () {
    return (
      <div>
        <Switch>
          <Route exact path='/company_admin/password_reset' component={PasswordReset} />
          <Route exact path='/company_admin/login' component={Login} />
          <Route exact path='/company_admin/add' component={CompanyAdd} />
          <Route component={Login} />
        </Switch>
      </div>
    )
  }
  renderSecurePages () {
    return (
      <div>
        <NaviBar history={this.props.history} />
        <div id='body-container'>
          <div id='body-content'>
            <NaviIconMenu history={this.props.history} />
            <Switch>
              <Route exact path='/company_admin' component={Dashboard} />
              <Route exact path='/company_admin/information' component={InformationList} />
              <Route exact path='/company_admin/information/detail/:id' component={InformationDetail} />

              <Route exact path='/company_admin/shared_files' component={SharedFileList} />
              <Route exact path='/company_admin/shared_files/detail/:id' component={SharedFileDetail} />

              <Route exact path='/company_admin/routine_task_home' component={RoutineTaskHome} />

              <Route exact path='/company_admin/personal_setting_home' component={PersonalSettingHome} />
              <Route exact path='/company_admin/password_change' component={PasswordChange} />
              <Route exact path='/company_admin/email_change' component={EmailChange} />
              <Route exact path='/company_admin/notification_setting_change' component={NotificationSettingChange} />

              <Route exact path='/company_admin/company/detail' component={CompanyDetail} />
              <Route exact path='/company_admin/company/edit' component={CompanyEdit} />

              <Route exact path='/company_admin/company_user' component={CompanyUserList} />
              <Route exact path='/company_admin/company_user/add' component={CompanyUserEdit} />
              <Route exact path='/company_admin/company_user/edit/:id' component={CompanyUserEdit} />
              <Route exact path='/company_admin/company_user/detail/:id' component={CompanyUserDetail} />

              <Route exact path='/company_admin/survey_answer' component={SurveyAnswer} />

              <Route component={Dashboard} />
            </Switch>
          </div>
        </div>
        <Footer />
      </div>
    )
  }

  render () {
    let view = null
    if (AWSAPI.isLoggedIn('companyAdmin')) {
      view = this.renderSecurePages()
    } else {
      view = this.renderPublicPages()
    }
    return view
  }
}

export default CompanyAdminApp



// WEBPACK FOOTER //
// ./src/company_admin/CompanyAdminApp.js